const replaceSpaces = (value: string) => value.replace(/[^a-z0-9:]+/gi, "_");

export default replaceSpaces;
